// import axios from 'axios';
// const Apibaseurl = require('../../constants/apibaseurl');
// var apibaseurl = Apibaseurl.getAPiUrl();
import { postRequest, getRequest } from '../../utils/request';
const url = 'api'

export const sendPaymentDetailsAPI = (data) => postRequest(`/${url}/fiatPaymentSetting/adminUpdateFiatPaymentSetting`, data,)
export const getIsEnablePaymentAPI = data => getRequest(`/${url}/fiatPaymentSetting/clientGetPlatformFiatPaymentSetting`)
export const getFaitPaymentAPI = data => getRequest(`/${url}/fiatPaymentSetting/clientGetOwnFiatPaymentSetting`)
export const enablePaymentAPI = (data) => postRequest(`/${url}/fiatPaymentSetting/adminEnableDisableFiatPaymentOption`, data,)